import $ from 'jquery';

$(document).ready(function () {

    if ($('.template-dashboard-main').length === 0) {
        return;

    }
    ///shows logout pop up when clicking on logout link////
    $(".log-out-hide").hide();
    $(".logout-link, .logout-mob").click(function() {
       $(".log-out-hide").show();
       $(".nav-wrap, .menu").hide();
   });
    $(".logout-link, .logout-mob").click(function() {
       $(".click-blur, .mobile-filter").addClass('active');
   });
   
   ///removes log-out pop with cancel button///
       $(".cancel-click").click(function() {
         $(".log-out-hide").hide();
         $(".click-blur, .mobile-filter").removeClass('active');
         $(".nav-wrap, .menu").show();
      });
});







